// Submenu — Trigger controller
//
// Button that opens/closes a submenu. Dispatches submenu:open on click
// and syncs its own .is-open class for icon/style changes.
//
// Usage:
//   <button data-controller="submenu--trigger" data-submenu-id="my-menu"
//     data-action="submenu--trigger#open submenu:close@window->submenu--trigger#close">

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.submenuId = this.element.dataset.submenuId
  }

  open() {
    if (this.element.classList.contains('is-open')) return

    this.dispatch('open', {
      prefix: 'submenu',
      target: window,
      detail: { id: this.submenuId },
    })

    this.element.classList.add('is-open')
  }

  close(event) {
    if (event.detail.id !== this.submenuId || !this.element.classList.contains('is-open')) return

    this.element.classList.remove('is-open')
  }
}
